<style lang="scss" src='./ZipCodeModal.scss' scoped ></style>
<template src="./ZipCodeModal.html"></template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import InputMap from '@/components/inputMap/InputMap'
export default {
  name: 'ZipCodeModal',
  components: {
    InputMap
  },
  data() {
    return {
      showModal: true,
      selected_pickup_store: null,
      address: null,
      loading_validate: false,
      show_invalid_address_message: false,
      show_valid_address_message: false,
      reload_on_close: false,
    };
  },
  watch:{
      getInitialAddress: {
        handler: function () {
          this.address = this.getInitialAddress;
        },
        deep: true,
      }
    },
  computed: {
    ...mapState(['zipCodeModal']),
    ...mapState(['user']),
    ...mapGetters("Main", ['getStoreList', 'getInitialAddress', 'getCurrentStore']),
  },

  methods: {
    ...mapMutations(["setZipCodeModal"]),
    ...mapMutations('Main', ['setCurrentStore', 'setValidAddress', 'setInitialAddress']),
    ...mapActions('Main', ['fnApiValidateDeliveryAddress']),

    setPickupStore(value) {
      this.setCurrentStore(value);
      this.setValidAddress(true);
      this.setZipCodeModal(false);
      window.location.reload(false);
    },

    async validateAddress() {
      this.loading_validate = true;
      this.show_invalid_address_message = false;
      this.show_valid_address_message = false;
      this.reload_on_close = false;
      let address = await this.$refs['address'].fnValidate();
      if(address && address.latitude && address.longitude){
        this.setValidAddress(false);
        this.setInitialAddress(address);
        let result = await this.fnApiValidateDeliveryAddress();
        switch(result){
          case 1:
            //this.setZipCodeModal(false);
            this.setValidAddress(true);
            this.show_valid_address_message = true;
            break;
          case 2:
            //this.setZipCodeModal(false);
            //window.location.reload(false);
            this.setValidAddress(true);
            this.show_valid_address_message = true;
            this.reload_on_close = true;
            break;
          case 3:
            this.setValidAddress(false);
            this.show_invalid_address_message = true;
            break;
          default:
            this.setValidAddress(false);
            break;
        }
      }
      this.loading_validate = false;
    },
    showAddressForm(){
      this.loading_validate = false;
      this.show_invalid_address_message = false;
    },
    validateIfReloadNeeded() {
      this.show_valid_address_message = false;
      
      if(this.reload_on_close){
        this.reload_on_close = false;
        window.location.reload(false);
      }
    },
  },
  beforeCreate() {},
  created() {
    this.address = this.getInitialAddress;
  },
  mounted() { },
  beforeDestroy() { },
};
</script>